<template>
  <div class="is-margin-bottom">
    <div class="columns is-multiline">
      <div
        class="column is-6">
        <r-label
          label="Typologie"
          :is-required="true"
          :red-check="hasCheck"
          :value="p.nature"></r-label>
        <div class="control">
          <div class="select is-fullwidth">
            <select
              v-model="p.nature"
              id="parkingNature">
              <option :value="null">
                Selectionnez un type
              </option>
              <option
                v-for="(c, i) in filteredTypesList"
                :value="c.value"
                :key="i"
                :id="c.value">
                {{ c.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div
        class="column is-6">
        <r-label
          label="Mode de vente"
          :is-required="false"
          :value="p.sales_mode"></r-label>
        <div class="control is-flex">
          <multiselect
            v-model="p.sales_mode"
            :options="filteredSalesModeList"
            class="multiselect--option-ico"
            :multiple="true"
            :close-on-select="false"
            :placeholder="''"
            track-by="value"
            label="label">
            <span
              slot="placeholder"
              class="multiselect__placeholder">Selectionner un type</span>
            <span slot="noOptions">La liste est vide</span>
          </multiselect>
          <p
            class="control"
            slot="addonRight">
            <a
              @click="removeParking"
              class="button is-square is-grey is-inverted is-border">
              <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
            </a>
          </p>
        </div>
      </div>
      <div class="column is-12">
        <r-label
          label=""
          :is-required="false"></r-label>
        <div class="control">
          <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
            <div
              class="column is-3 has-background-white"
              v-for="e in filteredSubtypesList"
              :key="'subtype-' + e.value + index">
              <input
                v-model="p.parking_type"
                :value="e.value"
                name="subtypes"
                :id="'subtype-' + e.value + index"
                type="checkbox"
                class="vadCheckradiocase is-fullwidth">
              <label :for="'subtype-' + e.value + index">{{ e.label }}</label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column is-4">
        <r-label
          label="Étage"
          :is-required="false"
          :value="p.floor"></r-label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="p.floor">
              <option :value="null">
                Selectionnez l'étage du lot
              </option>
              <option
                v-for="c in floorsList"
                :value="c.value"
                :key="c.value">
                {{ c.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-5">
        <r-label
          label="Détails / Informations / N°"
          for="remuneration"
          :value="p.info"
          :is-required="false"></r-label>
        <div class="control is-expanded">
          <v-input
            :has-addons="true"
            :id="'parking_info' + p.pk"
            :name="'parking_info' + p.pk"
            @input="p.info = $event"
            :model="p.info"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="Infos">
          </v-input>
        </div>
      </div>
      <div style="display: none;">
        <div class="control">
          <v-input
            :id="'parking_is_info' + p.pk"
            :name="'parking_is_info' + p.pk"
            @input="p.info = $event"
            :model="p.info"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="Infos">
          </v-input>
        </div>
      </div>
    </div>
    <div class="deuxieme bloc columns">
      <div class="column is-3">
        <r-label
          label="Prix HT"
          :red-check="hasCheck"
          :value="p.sale_price_ht"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            id="sale_price_ht"
            name="sale_price_ht"
            @click="selectedInput = 'ht'"
            @input="updateSalePriceHt($event)"
            :model="roundedValue(p.sale_price_ht)"
            @change="p.sale_price_ht"
            input-type="number"
            :three-space="true"
            v-validate="'required|decimal:2'"
            :errors-bag="errors"
            data-vv-value-path="val"
            :number="true"
            data-vv-as="Prix HT ">
            <p
              v-if="selectedInput === 'ht'"
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <i class="fal fa-check-circle"></i>
              </a>
            </p>
            <p
              class="control"
              slot="addonRight">
              <a class="button is-static is-border">
                <span class="icon"><i class="fas fa-euro-sign"></i></span><span>HT</span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
      <div class="column is-narrow">
        <r-label
          label="Tva"
          :is-required="false"
          :value="p.tva"
          :truncate="false"></r-label>
        <div class="field is-grouped">
          <div class="control">
            <div class="select">
              <select
                class="has-text-weight-medium"
                v-model.number="p.tva"
                @change="updateTva(p.tva, p.sale_price_ttc, null)">
                <option
                  v-for="(tvaVal, idx) in tvaList"
                  :value="tvaVal"
                  :key="tvaVal + '-' + idx">
                  <span v-if="tvaVal !== 'autre'">{{ tvaVal | tvaLabelRounded }}%</span>
                  <span v-else>{{ tvaVal }}</span>
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <r-label
          label="Prix TTC"
          :red-check="hasCheck"
          :value="p.sale_price_ttc"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            id="sale_price_ttc"
            name="sale_price_ttc"
            @click="selectedInput = 'ttc'"
            @input="updateSalePrice($event)"
            :model="roundedValue(p.sale_price_ttc)"
            @change="p.sale_price_ht"
            input-type="number"
            :three-space="true"
            v-validate="'required|decimal:2'"
            :errors-bag="errors"
            data-vv-value-path="val"
            :number="true"
            data-vv-as=" ">
            <p
              v-if="selectedInput === 'ttc'"
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <i class="fal fa-check-circle"></i>
              </a>
            </p>
            <p
              class="control"
              slot="addonRight">
              <a class="button is-static is-border">
                <span class="icon"><i class="fas fa-euro-sign"></i></span><span>TTC</span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { logAnalyticEvent } from '../../firebaseApp'
import { DefaultValues } from '../../mixins'
import LotMixin from './LotMixin'
import { LOT_SALES_MODE } from '../../mixins/DefaultValues'

export default {
  name: 'LotParkingItem',
  filters: {
    tvaLabelRounded (value) {
      if (value.toString().split('.').length === 1) {
        return `${value}.0`
      } else {
        return value
      }
    }
  },
  mixins: [DefaultValues, LotMixin],
  props: {
    source: {
      type: Object,
      required: true
    },
    defaultParkingType: {
      type: Array
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      parkingTypeList: ['Sous-sol', 'Rez-de-chaussée', 'Aérien', 'Extérieur', 'Intérieur', 'Couvert', 'Commandé'],
      tvaList: [20, 'autre']
    }
  },
  computed: {
    tva () {
      return Number((this.p.sale_price_ttc - this.p.sale_price_ht) * 100 / this.p.sale_price_ht).toFixed(2)
    },
    p () {
      return this.source
    },
    parkingType () {
      return this.defaultParkingType || []
    },
    filteredSalesModeList () {
      return this.salesmodeList.filter(x => !x.hide)
    },
    filteredTypesList () {
      return this.typesList.filter((x) => x.show.includes('parking'))
    },
    filteredSubtypesList () {
      return this.subtypesList.filter((x) => x.show.includes('parking'))
    }
  },
  created () {
    this.p.nature = this.p.nature.toUpperCase()
    if (this.lotPk) this.p.lot_pk = this.lotPk
    if (!this.p.parking_type) this.p.parking_type = []
    if (!this.p.floor) this.p.floor = null
    if (this.p.sales_mode && this.p.sales_mode.length) {
      this.p.sales_mode = this.p.sales_mode.map(s => {
        return LOT_SALES_MODE[s]
      })
    }
  },
  methods: {
    removeParking () {
      this.$emit('removeParking')
    },
    /**
    * update sale price ttc
    * @param {number} valSalePrice
    */
    updateSalePrice (valSalePrice) {
      if (this.p.tva === null) {
        this.p.sale_price_ttc = Number(valSalePrice)
        return this.p.sale_price_ttc
      } else {
        let salePriceTTC, salePriceHT
        if (!this.p.sale_price_ttc || Number(valSalePrice) !== Number(this.p.sale_price_ttc)) {
          salePriceTTC = valSalePrice
          salePriceHT = salePriceTTC / (1 + (this.p.tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
          this.p.sale_price_ht = Number(salePriceHT)
          this.p.sale_price_ttc = Number(salePriceTTC)
        }
      }
    },
    /**
    * update sale price ht
    * @param {number} valSalePriceHt
    */
    updateSalePriceHt (valSalePriceHt) {
      if (this.p.tva === null) {
        this.p.sale_price_ht = Number(valSalePriceHt)
        return this.p.sale_price_ht
      } else {
        let salePriceTTC, salePriceHT
        if (!this.p.sale_price_ht || Number(valSalePriceHt) !== Number(this.p.sale_price_ht)) {
          salePriceHT = valSalePriceHt
          salePriceTTC = salePriceHT * (1 + (this.p.tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
          this.p.sale_price_ttc = Number(salePriceTTC)
          this.p.sale_price_ht = Number(salePriceHT)
        }
      }
    },
    updateTva (val) {
      if (val === 20) {
        this.$set(this.p, 'tva', val)
      } else {
        this.$set(this.p, 'tva', null)
      }
    }
  }
}
</script>
